export let QUERIES = /*#__PURE__*/function (QUERIES) {
  QUERIES["MEDIUMMOBILE"] = "mediumMobile";
  QUERIES["LARGEMOBILE"] = "largeMobile";
  QUERIES["TABLET"] = "tablet";
  QUERIES["DESKTOP"] = "desktop";
  QUERIES["LARGEDESKTOP"] = "largeDesktop";
  return QUERIES;
}({});
export const TOKEN = {
  mediumMobile: "breakpointMediumMobile",
  largeMobile: "breakpointLargeMobile",
  tablet: "breakpointTablet",
  desktop: "breakpointDesktop",
  largeDesktop: "breakpointLargeDesktop"
};
export function getBreakpointWidth(name, theme, pure) {
  return pure ? theme.orbit[TOKEN[name]] : `(min-width: ${theme.orbit[TOKEN[name]]}px)`;
}